import Typography from "typography";
import bootstrapTheme from "typography-theme-bootstrap";

//const typography = new Typography({baseFontSize: "18px"});
const typography = new Typography(bootstrapTheme);

export default typography;



// WEBPACK FOOTER //
// ./src/components/typography.js